import MuxPlayer from "@mux/mux-player-react";

import { Video } from "@/gen/realtime";
import { useViewerContext } from "@/hooks/useViewerContext";

export const VideoPreview = ({ video }: { video: Pick<Video, "id" | "muxPlaybackId"> }) => {
    const { viewer } = useViewerContext();

    return (
        <MuxPlayer
            playbackId={video.muxPlaybackId}
            metadata={{
                video_id: video.id,
                video_title: "Uploaded video",
                viewer_user_id: viewer?.id,
            }}
        />
    );
};
